import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { FocusViewResponse } from './focus.model';

@Injectable({ providedIn: 'root' })
export class FocusService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/api/focus`;

  getTodayView(): Observable<FocusViewResponse> {
    return this.http.get<FocusViewResponse>(`${this.baseUrl}/today`);
  }
}
